export const SERVICE_NAME = 'HoneymoonSalad';
export const LOCALFORAGE_YN = process.env.REACT_APP_TYPE === 'LOCALFORAGE';
// export const LOCALFORAGE_YN = true;
export const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
